import { getAllFacilities } from './getAllFacilities';
import { EFacilityType, type NonEmptyArray, type TJsonQuery } from './types';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

const LIVING_CONDITIONS: EFacilityType[] = [EFacilityType.KidsAllowed, EFacilityType.PetsAllowed];

export function getLivingConditions(jsonQuery: TJsonQuery): NonEmptyArray<EFacilityType> | null {
  const facilities = (getAllFacilities(jsonQuery) || []).filter(f => LIVING_CONDITIONS.includes(f));

  return nonEmptyArrayOr(facilities);
}
